module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cetus/cet_vis-ee856e573cef9477bd87372a48b36c99.jpg";